import { BiEdit } from "react-icons/bi"; 
import { IoIosArrowRoundBack } from "react-icons/io";  
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import axios from 'axios';
import "swiper/css/navigation";
import { Navigation } from "swiper/modules"; 
import './jewelleryswiper.css'
export const JewelryDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [admin, setAdmin] = useState('');

  useEffect(() => {
    fetchItemDetails();
  }, [id]);

  useEffect(() => {
    const isAdmin = localStorage.getItem('admin');
    setAdmin(isAdmin);
  }, []);

  const fetchItemDetails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}item/items/${id}`);
      console.log(response,"get api response");
      setItem(response.data.data); // Assuming your backend returns item details in 'data' property
   
    } catch (error) {
      console.error('Failed to fetch item details:', error);
      // Handle error state or display error message
    }
  };

  const handleUpdate = () => {
    navigate(`/update/${id}`); // Navigate to the update form page
  };

  if (!item) return <div>Loading...</div>;

  return (
    <div className="p-4 mt-20">
     <div className={`text-2xl font-bold mb-4 flex ${admin ? 'justify-between' : 'justify-center'}  mx-auto md:justify-around items-center`}>
  <div onClick={() => navigate('/home')} className="text-cyan-950 text-center cursor-pointer">
    <IoIosArrowRoundBack size={50} />
  </div>
  <h1 className="text-center  text-cyan-950">Product Details</h1>
  {admin &&
    <div className="text-cyan-950 font-bold text-center text-xl cursor-pointer" onClick={handleUpdate}>
      <BiEdit size={30}/>
    </div>
  } 
  {
    !admin && <div className="text-white font-bold text-center text-xl cursor-pointer" >
    <BiEdit size={30}/>
  </div>
  } 
</div>
 <div className="flex items-center justify-center py-5">
 {admin ? (<h1 className="text-center  text-xl uppercase font-bold text-red-800">Admin</h1>):(<h1 className="text-center  text-xl uppercase font-bold text-green-900">User</h1>)}
  </div> 


      <Swiper slidesPerView={1} spaceBetween={10} loop={true} navigation={true} 
  modules={[Navigation]}  className="mb-4">
        {item.image && (
          <SwiperSlide>
            <img
              src={item.image}
              alt={item.itemName}
              className="w-full h-[350px] md:w-[500px] md:h-[500px] object-contain rounded-lg mx-auto"
            />
          </SwiperSlide>
        )}
           {item.image2 && (
          <SwiperSlide>
            <img
              src={item.image2}
              alt={item.itemName}
              className="w-full h-[350px] md:w-[500px] md:h-[500px] object-contain rounded-lg mx-auto"
            />
          </SwiperSlide>
        )}
        {item.video && (
          <SwiperSlide>
            <video controls className="w-full h-[350px] md:w-[500px] md:h-[500px] object-contain rounded-lg mx-auto">
              <source src={item.video} type="video/mp4" />
            </video>
          </SwiperSlide>
        )}
      </Swiper>

      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-5 mx-auto max-w-4xl">
        
        {admin && (
          <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
            <p className="font-semibold">Gold Rate:</p>
            <p>{item.goldRate}<span className="font-medium"> Rs</span></p>
          </div>
        )}
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Round Diamond Weight:</p>
          <p>{item.roundDiamondWeight} <span className="font-medium">carat</span></p>
        </div>
        {admin && (
          <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
            <p className="font-semibold">Round Diamond Rate:</p>
            <p>{item.roundDiamondRate}<span className="font-medium"> Rs</span></p>
          </div>
        )}
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Polki Diamond Weight:</p>
          <p>{item.polkiDiamondWeight} <span className="font-medium">carat</span></p>
        </div>
        {admin && (
          <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
            <p className="font-semibold">Polki Diamond Rate:</p>
            <p>{item.polkiDiamondRate}<span className="font-medium"> Rs</span></p>
          </div>
        )}
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Stone Weight:</p>
          <p>{item.stoneWeight} <span className="font-medium">carat</span></p>
        </div>
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Stone Type:</p>
          <p>{item.stoneType}</p>
        </div>
        {admin && (
          <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
            <p className="font-semibold">Stone Rate:</p>
            <p>{item.stoneRate}<span className="font-medium"> Rs</span></p>
          </div>
        )}
        {admin && (
          <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
            <p className="font-semibold">Labour Charge:</p>
            <p>{item.laborCharge}<span className="font-medium"> Rs</span></p>
          </div>
        )}
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Gross Weight:</p>
          <p>{item.grossWeight} <span className="font-medium">Gram</span></p>
        </div>
        <div className="flex items-center justify-between text-gray-700 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
          <p className="font-semibold">Total Rate:</p>
          <p>{item.totalRate} <span className="font-medium">Rs</span></p>
        </div>
      </div> */}
     <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-5 mx-auto max-w-4xl">
  {/* Gold Section */}
  <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
  <p className="font-semibold text-gray-700">Gold Purity:</p>
{
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
  <p>{item.caratTypes ? item.caratTypes : 'N/A'} <span className="font-medium">Carat</span></p>
</div>
{ admin &&
  <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
    <p className="font-semibold text-gray-700">Gold Weight:</p>
    {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
    <p>{item.netGoldWeight} <span className="font-medium">Gram</span></p>
  </div>
  }
  {
    admin &&  <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
    <p className="font-semibold text-gray-700">Gold Rate:</p>

    <p>{item.goldRate} <span className="font-medium">Rs</span></p>
  </div>
  }
 {
  admin &&  <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
  <p className="font-semibold text-gray-700">Total Gold Rate:</p>
  <p>{item.totalGoldRate ? item.totalGoldRate : 'N/A'} <span className="font-medium">Rs</span></p>
</div>
 }
 
 

  {/* Round Diamond Section */}
  {item.diamondType.map((stone) => (
    <React.Fragment key={stone._id}>
      <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
        <p className="font-semibold text-gray-700">Diamond Type:</p>
        {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
        <p>{stone.type}</p>
      </div>
      <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
        <p className="font-semibold text-gray-700">Diamond Weight:</p>
        {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
        <p>{stone.weight} <span className="font-medium">Carat</span></p>
      </div>
    
   {
    admin &&   <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 px-7 rounded-lg transition duration-300 hover:shadow-lg">
    <p className="font-semibold text-gray-700">Diamond Rate:</p>

    <p>{stone.rate} <span className="font-medium">Rs</span></p>
  </div>
   }
   {
    admin &&  <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 px-7 rounded-lg transition duration-300 hover:shadow-lg">
    <p className="font-semibold text-gray-700">Total DiamondRate:</p>
    <p>{stone.rate * stone.weight} <span className="font-medium">Rs</span></p>
    </div>
   }
     
  
    </React.Fragment>
  ))}

  {/* Stone Section */}
  {item.stoneType.map((stone) => (
    <React.Fragment key={stone._id}>
      <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
        <p className="font-semibold text-gray-700">Stone Type:</p>
        {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
        <p>{stone.type}</p>
      </div>
      <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
        <p className="font-semibold text-gray-700">Stone Weight:</p>
        {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
        <p>{stone.weight} <span className="font-medium">Carat</span></p>
      </div>
   {
    admin && <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 px-7 rounded-lg transition duration-300 hover:shadow-lg">
    <p className="font-semibold text-gray-700">Stone Rate:</p>
    <p>{stone.rate} <span className="font-medium">Rs</span></p>
  </div>
   }
     {
admin &&   <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 px-7 rounded-lg transition duration-300 hover:shadow-lg">
<p className="font-semibold text-gray-700">Total Stone Rate:</p>
<p>{stone.rate * stone.weight} <span className="font-medium">Rs</span></p>
</div>
     }
    
     
    </React.Fragment>
  ))}
   <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
      <p className="font-semibold text-gray-700">Gross Weight:</p>
      {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
      <p>{item.grossWeight} <span className="font-medium">Gram</span></p>
    </div>

  {/* Labour Charge */}
  {admin && (
    <div className="flex md:flex-col gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg">
      <p className="font-semibold text-gray-700">Labour Charge:</p>
      
      <p>{item.laborCharge} <span className="font-medium">Rs</span></p>
    </div>
  )}

  {/* Overall Total */}
  <div className={`flex ${admin ? 'flex-col'  : 'flex-row'} gap-3 md:gap-0 bg-white shadow-md p-4 rounded-lg transition duration-300 hover:shadow-lg`}>
    <p className="font-semibold text-gray-700">Overall Total Rate:</p>
    {
  !admin &&  <p>
  <div className="p-1"></div>
 </p>
}
<p>
  {/* Calculation for total item rate */}
  {(() => {
    const totalDiamondRate = item.diamondType.reduce(
      (acc, stone) => acc + stone.rate * stone.weight,
      0
    );
    const totalStoneRate = item.stoneType.reduce(
      (acc, stone) => acc + stone.rate * stone.weight,
      0
    );
    const totalGoldRate = item.totalGoldRate || 0;
    const laborCharge = item.laborCharge || 0;

    // Total item rate
    const totalItemRate =
      totalDiamondRate + totalStoneRate + totalGoldRate + laborCharge;

    return totalItemRate;
  })()}{" "}
  <span className="font-medium">Rs</span>
</p>
  </div>
</div>

    </div>
  );
};

export default JewelryDetails;
